export default __webpack_public_path__ + "ac0a78bd098331620bbac684c45eb761.png";